"use client";

import NextLink from "next/link";
import { usePathname } from "next/navigation";
import { ComponentProps } from "react";
import { useMobileMenu } from "@/contexts/frontend/mobile-menu-context";

/**
 * Next treats a link to the page you are already on as no navigation at all, so nothing happens on
 * click. Scrolling to the top gives it a visible result instead.
 */
const PageLink = (props: ComponentProps<typeof NextLink>) => {
	const pathname = usePathname();
	const { setMobileOpen } = useMobileMenu() ?? {};

	return (
		<NextLink
			{...props}
			onClick={(event) => {
				props.onClick?.(event);

				if (props.href.toString() !== pathname || event.metaKey || event.ctrlKey || props.target === "_blank") return;

				event.preventDefault();
				setMobileOpen?.(false);
				window.scrollTo({ top: 0, behavior: "smooth" });
			}}
		/>
	);
};

export default PageLink;
